import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { VideoCard } from './VideoCard';

export const Carousel = ({ videoList, month }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    swipeToSlide: true,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    centerMode: false,
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          color: '#7c3aed',
          fontSize: '32px',
          transform: 'scale(2.5)',
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          color: '#7c3aed',
          fontSize: '32px',
          transform: 'scale(2.5)',
        }}
        onClick={onClick}
      />
    );
  }

  return (
    <div key={month} className="slider-container m-4">
      <Slider
        className="video-carousel"
        {...settings}
        responsive={[
          {
            breakpoint: 768,
            settings: 'unslick',
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ]}
      >
        {videoList?.map((video, idx) => (
          <div key={idx}>
            <VideoCard video={video} idx={idx} />
          </div>
        ))}

        {/* Ghost video cards to fill space up to 4 */}
        {window.innerWidth > 768 &&
          Array.from({ length: Math.max(0, 4 - (videoList?.length || 0)) }).map(
            (_, idx) => (
              <div
                key={`ghost-${idx}`}
                className="ghost-card bg-gray-200 rounded-md"
                style={{ width: '250px', height: '150px', margin: '0 10px' }}
              />
            )
          )}
      </Slider>
    </div>
  );
};
